import { produce } from 'immer'
import * as services from '@/pages/toolsPage/service'

export type SaveToolReq = {
  story_ids: string[]
  group_id: string
  name: string
  desc: string
  ext_id: string
  extra: string
}

export type toolListReq = {
  group_ids: string[]
  fuzzy?: string
  page_num?: number
  page_size?: number
  creator_ids?: string[]
  creator_time_start?: number
  creator_time_end?: number
  update_time_start?: number
  update_time_end?: number
}

export type toolDetailReq = {
  ids: string[]
  story_ids: string[]
}

export type toolMoveReq = {
  ids: string[]
  group_id: string
}

export type toolGroupSaveReq = {
  group_list: toolGroup[]
}

export interface toolGroup {
  parent_id: string
  name: string
}

export type toolBindReq = {
  tool_ids: string[]
  story_id: string
}

export type saveToolRecordReq = {
  business_id: string
  tool_id: string
  tool_name: string
  total_time: number
  finish_status: number // 0 自动结束 1 手动结束
  step_time: number[]
  avg_step_time: number
  step_rate: number
}

const UserModel = {
  namespace: 'toolsLibrary',

  state: {
    toolGroupList: [],
    toolList: [],
    searchValue: {
      page_num: 1,
      page_size: 20,
      fuzzy: null,
    },
    loading: false,
    groupId: '',
    totalNum: 0,
  },

  subscriptions: {},
  effects: {
    // 保存自定义评价
    *saveTool({ payload }, { put, call, select }) {
      yield put({
        type: 'setState',
        payload: { toolList: [] },
      })
      const res = yield call(services.saveTool, payload)
      return res
    },
    // 获取工具列表
    *fetchToolsList({ payload }, { put, call, select }) {
      const res = yield call(services.fetchToolsList, payload)
      yield put({
        type: 'setState',
        payload: {
          loading: false,
          toolList: res?.data?.data || [],
          totalNum: res?.data?.page?.total,
        },
      })
      return res
    },
    // 获取工具详情
    *fetchToolsDetail({ payload }, { put, call, select }) {
      const res = yield call(services.fetchToolsDetail, payload)
      return res
    },
    // 工具批量分组
    *toolsMove({ payload }, { put, call, select }) {
      const res = yield call(services.toolsMove, payload)
      return res
    },
    // 工具批量删除
    *toolsDelete({ payload }, { put, call, select }) {
      const res = yield call(services.toolsDelete, payload)
      return res
    },
    // 工具分组列表
    *FetchToolsGroup({ payload }, { put, call, select }) {
      const res = yield call(services.FetchToolsGroup, payload)
      const list = res?.data?.group_list
      list.sort((a, b) => {
        if (a.name === '未分组') return -1
        if (b.name === '未分组') return 1
        return 0
      })
      yield put({
        type: 'setState',
        payload: {
          toolGroupList: list,
          loading: false,
        },
      })
      return list
    },
    // 工具分组保存
    *toolsGroupSave({ payload }, { put, call, select }) {
      const res = yield call(services.toolsGroupSave, payload)
      return res
    },
    // 工具分组删除
    *toolsGroupDelete({ payload }, { put, call, select }) {
      const res = yield call(services.toolsGroupDelete, payload)
      return res
    },
    // 工具库一键清空
    *emptyToolsGroups({ payload }, { put, call, select }) {
      const res = yield call(services.emptyToolsGroups, payload)
      return res
    },
    // 工具绑定
    *toolsBind({ payload }, { put, call, select }) {
      const res = yield call(services.toolsBind, payload)
      return res
    },
    // 保存工具使用记录
    *saveToolsRecord({ payload }, { put, call, select }) {
      const res = yield call(services.saveToolsRecord, payload)
      return res
    },
    // 查询工具使用记录
    *queryToolsRecord({ payload }, { put, call, select }) {
      const res = yield call(services.queryToolsRecord, payload)
      return res
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    cleared: produce((state) => {
      state.toolGroupList = []
      state.toolList = []
      state.searchValue = {
        page_num: 1,
        page_size: 20,
        fuzzy: null,
      }
      state.loading = false
      state.groupId = ''
      state.totalNum = 0
    }),
    resetSearchVal: produce((state) => {
      state.searchValue = {
        page_num: 1,
        page_size: 20,
        fuzzy: null,
      }
    }),
  },
}

export default UserModel
